'use client'

import { useEffect } from 'react'
import { useSearchParams } from 'next/navigation'
import { storeRef } from '@/lib/sharing'

export default function RefCapture() {
  const searchParams = useSearchParams()

  useEffect(() => {
    const ref = searchParams.get('ref')
    if (ref) storeRef(ref)
  }, [searchParams])

  return null
}
